import React from 'react';
import { IoCopyOutline } from 'react-icons/io5';

import { useDispatch } from 'src/store/useDispatch';
import { setAppAlert } from 'src/store/slice/appAlert';

import { FieldCard as Card, FieldLabel, FieldValue, FieldValueRow, CopyIconButton } from '../styled';

type FieldCardProps = {
  label: string;
  value?: React.ReactNode;
  copyValue?: string;
  /** Show copy control when copyValue is provided (default true). */
  showCopy?: boolean;
};

const FieldCard: React.FC<FieldCardProps> = ({ label, value, copyValue, showCopy = true }) => {
  const dispatch = useDispatch();
  const canCopy = showCopy && Boolean(copyValue);

  const handleCopy = async () => {
    if (!copyValue) return;
    try {
      await navigator.clipboard.writeText(copyValue);
      dispatch(setAppAlert({ message: `${label} copied`, isSuccess: true }));
    } catch {
      dispatch(setAppAlert({ message: 'Failed to copy', isSuccess: false }));
    }
  };

  return (
    <Card>
      <div>
        <FieldLabel>{label}</FieldLabel>
        <FieldValueRow>
          <FieldValue title={typeof value === 'string' ? value : copyValue}>{value ?? '—'}</FieldValue>
        </FieldValueRow>
      </div>
      {canCopy && (
        <CopyIconButton type="button" aria-label={`Copy ${label}`} onClick={handleCopy}>
          <IoCopyOutline size={16} />
        </CopyIconButton>
      )}
    </Card>
  );
};

export default FieldCard;
